// extracted by mini-css-extract-plugin
export default {"uploadIcon":"UploadPhotoBlock_uploadIcon__8C8mK","badge":"UploadPhotoBlock_badge__8xJdM"};